<template>
  <div>
    <div class="upload-wrap">
      <div class="bg-wrap" v-if="!isShowImgIcon && newImgUrl">
        <img :src="newImgUrl" class="bg-wrap-img" />
      </div>
      <el-upload
        ref="customImgUploadRef"
        :action="actionUrl"
        :limit="1"
        :accept="accept"
        :list-type="isShowImgIcon ? 'picture-card' : ''"
        :show-file-list="isShowImgIcon"
        :file-list="fileList"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :on-preview="handlePictureCardPreview"
        :class="[
          isShowImgIcon ? 'img-uploader' : '',
          fileList.length ? 'hide-upload' : '',
        ]"
      >
        <img
          class="upload-box"
          src="https://cdn-image.yucrm.cn/3a3d0061f7c14747b871cd9d06009bf4.png"
          alt=""
          v-if="isShowImgIcon"
        />
        <jd-button type="blueText" :disabled="isDisabled" v-else
          >上传图片</jd-button
        >
      </el-upload>
    </div>
    <div class="wrapper-box" v-if="dialogVisible">
      <div class="mask-box"></div>
      <div class="close-icon" @click="dialogVisible = false">
        <i class="el-icon-close"></i>
      </div>

      <div class="img-wrap">
        <img :src="dialogImageUrl" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
const DEFAULT_WIDTH = 200;
const DEFAULT_HEIGHT = 200;
export default {
  props: {
    accept: {
      type: String,
      default: ".jpg,.png,.jpeg",
    },
    extensions: {
      type: Array,
      default: () => [".jpg", ".png", ".jpeg"],
    },
    imgUrl: {
      type: String,
      default: "",
    },
    limitSize: {
      type: Number,
      default: 0,
    },
    // 图片宽度
    pw: {
      type: Number,
      default: 0,
    },
    // 图片高度
    ph: {
      type: Number,
      default: 0,
    },
    // 是否是图片图标
    isShowImgIcon: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actionUrl: "/jd-hd-web/image/upload",
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  computed: {
    newImgUrl: {
      get() {
        return this.imgUrl;
      },
      set(val) {
        this.$emit("update:imgUrl", val);
      },
    },
  },
  watch: {
    newImgUrl: {
      handler(newVal, oldVal) {
        if (this.isShowImgIcon && newVal) {
          this.fileList = [{ url: newVal, name: "image" }];
        } else {
          this.fileList = [];
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    imgchecked(file, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
      return new Promise((resolve, reject) => {
        const extension = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();

        if (!this.extensions.includes(extension)) {
          this.$message.info("所选图片格式不符，请重新选择");
          reject();
        }
        if (this.limitSize) {
          if (file.size > this.limitSize * 1024 * 1024) {
            this.$message.info(`图片大小不能超过${this.limitSize}M`);
            reject();
          }
        }
        if (this.pw && this.ph) {
          const image = new Image();
          const _URL = window.URL || window.webkitURL;
          image.onload = () => {
            const valid = image.width === width && image.height === height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };

          image.src = _URL.createObjectURL(file);
        } else {
          resolve(true);
        }
      });
    },
    async beforeUpload(file) {
      const flag = await this.imgchecked(file, this.pw, this.ph);
      return flag;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.newImgUrl = "";
      this.fileList = [];
    },
    handleSuccess(res, file, fileList) {
      if (res.code != 1) {
        this.$message.error(res.message);
        return;
      }
      this.newImgUrl = res.data;
      this.$message.success("上传成功");
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-wrap {
  width: fit-content;
  display: flex;
  align-items: center;
  .img-uploader {
    width: 80px;
    height: 80px;
    border-radius: 2px;
    position: relative;
    overflow: hidden;
  }
  .bg-wrap {
    margin-right: 8px;
    width: 80px;
    &-img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  /deep/ .el-upload--picture-card {
    width: 80px !important;
    height: 80px !important;
    border: none;
  }
  /deep/ .el-upload-list__item-thumbnail {
    object-fit: cover;
  }

  /deep/ .el-upload-list__item {
    width: 80px !important;
    height: 80px !important;
  }
  .hide-upload {
    /deep/ .el-upload--picture-card {
      display: none !important;
    }
  }

  .upload-box {
    width: 80px;
    height: 80px;
    border-radius: 2px;
    cursor: pointer;

    i {
      color: #999;
      font-size: 26px;
    }

    .text {
      margin-top: 7px;
      font-size: 12px;
      color: #333333;
    }
  }

  .upload-limit {
    margin-left: 16px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
  }
}
.wrapper-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  .mask-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.5;
    background: #000;
  }
  .img-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    align-items: center;
    img {
      transform: scale(1) rotate(0deg);
      margin-left: 0px;
      margin-top: 0px;
      max-height: 100%;
      max-width: 100%;
      overflow-clip-margin: content-box;
      overflow: clip;
    }
  }
  .close-icon {
    position: absolute;
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    opacity: 0.8;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
